import { Link, useLocation } from 'react-router-dom';
import type { NavItem } from './sidebarConfig';

interface NavSectionProps {
  navConfig: NavItem[];
}

export default function NavSection({ navConfig }: NavSectionProps) {
  const pathname = useLocation().pathname;

  return (
    <ul className="space-y-0.5">
      {navConfig.map((item) => {
        const isActive = pathname === item.path || item.children?.some((c) => c.path === pathname);
        const Icon = item.icon;

        if (item.children?.length) {
          return (
            <li key={item.path}>
              <div className="mb-1 flex items-center gap-2.5 px-3 py-2 text-xs font-semibold uppercase tracking-wider text-slate-400">
                <Icon className="h-4 w-4" />
                {item.title}
              </div>
              <ul className="space-y-0.5 border-l border-white/10 pl-3 ml-2">
                {item.children.map((child) => {
                  const ChildIcon = child.icon;
                  const childActive = pathname === child.path;
                  return (
                    <li key={child.path}>
                      <Link
                        to={child.path}
                        className={`flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                          childActive
                            ? 'bg-primary-500/20 text-primary-300'
                            : 'text-slate-300 hover:bg-white/10 hover:text-white'
                        }`}
                      >
                        <ChildIcon className="h-4 w-4 shrink-0 opacity-80" />
                        {child.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        }

        return (
          <li key={item.path}>
            <Link
              to={item.path}
              className={`flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-primary-500/20 text-primary-300'
                  : 'text-slate-300 hover:bg-white/10 hover:text-white'
              }`}
            >
              <Icon className="h-4 w-4 shrink-0 opacity-80" />
              {item.title}
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
